import React, { useMemo } from 'react';
import _ from 'lodash';
import {
  FlagIndicator, // ラジオボタンの「有無」
  AcceptanceForeignWorkersFlag, // 外国人就労者受入有無
  ATTACH_DOCUMENT_TYPE_COMPANY,
  EXISTANCE_FLAG,
  PREFECTURE_GROUPS, //都道府県
  REGIONAL_DEVELOPMENT_BUREAU_NONE, //振興局
  EXISTANCE_EXCLUSION_FLAG,
} from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';
import { joinTel } from '../../utilities/stringUtil';
import { DateInput } from '../DateInput';
import { Description } from '../Description';
import AttachDocument from '../../components/forms/AttachDocument';
import {
  INSURANCE_STATUS,
  WORKER_COMPENSATION_FLAG,
  CONST_SUBSCRIPTION_FLAG,
  getInsuranceStatus,
  getWorkmansCompensationInsuranceStatus,
  getKentaikyoInsuranceStatus,
  getChutaikyoInsuranceStatus,
  ENTERPRISE_SUBSCRIPTION_FLAG,
  isConstructionIndustryPermissionStatus,
  isOtherSubscriptionStatus,
  isAcceptanceForeignWorkersStatus,
  partnerCompanyFindStatus,
  filterComboBoxHealthInsuranceTypeWhenExist,
  filterComboBoxHealthInsuranceTypeWhenExclusion,
  filterComboBoxPensionInsuranceTypeWhenExist,
  filterComboBoxPensionInsuranceTypeWhenExclusion,
  isValidWordsWorkCategory,
} from '../../utilities/companySafetyUtil';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
  FormElementContainerItem,
  FormElementContainer,
} from '../CommonFormComponents';
import { CcusLineComponent, CcusTitleBlock } from '../CcusFormComponent';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { FormSelect } from '../FormSelect';
import { FormInput } from '../FormInput';
import { AdditionalInfoAboutOthers } from '../AdditionalInfoAboutOthers';
import { CompanyInsuranceManual } from '../CompanyInsuranceManual';
import { InsuranceDocumentMyNumberCardWarning } from '../InsuranceDocumentAttention';
import CompanySecurityInformation from '../CompanySecurityInformation';
import CompanyLicenseInformation from '../CompanyLicenseInformation';
import { WorkerAddOnCompensationForm } from '../WorkerAddOnCompensationForm';
import { CompanyOtherIndustryLicenseInformation } from '../CompanyOtherIndustryLicenseInformation';
import { OldAttachmentPermission } from '../OldAttachmentPermission';

const TextInput = props => {
  if (props.disabled) {
    return <span>{props.value}</span>;
  }
  return <input {...props} />;
};

/**
 * 会社情報確認 画面  労務安全項目 タブ
 * 画面遷移
 *  - 協力会社管理者でログイン > 会社情報確認 > 労務安全項目
 *
 * @param values {object} 入力値
 * @param messages {object}
 * @param checkboxList {object}
 * @param comboboxList {object}
 * @param ccusformValues {object}
 * @param events {func} イベントハンドラ
 * @param readOnly {boolean} 表示(プレビュー)画面 / 編集画面
 * @param isAgency {boolean} 代行登録かどうか
 * @param companyDocuments {array}
 * @param documentCodes {array}
 * @param bureaux {array}
 * @param attentionBox {boolean}
 * @param eventCompanyBranchPermissionCommon {object}
 * @param setFormValuesSecurityCompanyPermission {func},
 * @param selectedCompanyId {string},
 * @param ccusDescription {HTMLElement},
 * @param ccusCompanyBranchPermissions {array}
 */
export const PartnerCompanySaftyForm = ({
  values,
  messages = {},
  checkboxList,
  comboboxList,
  ccusformValues,
  events,
  readOnly = false,
  isAgency = false,
  companyDocuments,
  documentCodes,
  bureaux,
  attentionBox = null,
  eventCompanyBranchPermissionCommon,
  selectedCompanyId,
  setFormValuesSecurityCompanyPermission,
  gotCcusValues,
  ccusDescription = null,
  ccusCompanyBranchPermissions = [],
}) => {
  const workerCategoryWarningText = useMemo(
    () =>
      !values.company_branch_foreigner.work_category ||
      isValidWordsWorkCategory(values.company_branch_foreigner.work_category)
        ? ''
        : messageUtility.getMessage('W-000-028'),
    [values.company_branch_foreigner.work_category]
  );

  const findStatusFn = (type, targetValue) => {
    return partnerCompanyFindStatus(type, targetValue, checkboxList);
  };

  //健康保険で加入フラグの値によって社会保険名称に表示する絞り込みを行う必要がある
  let healthInsuranceTypesComboBoxList = _.cloneDeep(
    comboboxList.health_insurance_types
  );
  //加入状況が「有」
  if (
    values.company_branch_insurance.health_insurance_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    healthInsuranceTypesComboBoxList = filterComboBoxHealthInsuranceTypeWhenExist(
      healthInsuranceTypesComboBoxList
    );
  }
  //適用除外
  if (
    values.company_branch_insurance.health_insurance_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    healthInsuranceTypesComboBoxList = filterComboBoxHealthInsuranceTypeWhenExclusion(
      healthInsuranceTypesComboBoxList,
      values.company_branch_insurance.health_insurance_reason_exclusion
    );
  }

  let pensionInsuranceTypesComboBoxList = _.cloneDeep(
    comboboxList.pension_insurance_types
  );
  //年金保険で加入フラグの値によって社会保険名称に表示する絞り込みを行う必要がある
  //加入状況が「有」
  if (
    values.company_branch_insurance.pension_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    pensionInsuranceTypesComboBoxList = filterComboBoxPensionInsuranceTypeWhenExist(
      pensionInsuranceTypesComboBoxList
    );
  }
  // 適用除外
  if (
    values.company_branch_insurance.pension_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    pensionInsuranceTypesComboBoxList = filterComboBoxPensionInsuranceTypeWhenExclusion(
      pensionInsuranceTypesComboBoxList
    );
  }
  const insuranceCcusMap = {
    healthInsurance: {
      health_insurance_flag: 'health_ins_status', // 健康保険加入状況
      health_insurance_reason_exclusion: 'health_ins_exclusion', // 健康保険適用除外理由
    },
    pensionInsurance: {
      pension_flag: 'pension_ins_status', // 年金保険加入状況
      pension_reason_exclusion: 'pension_ins_exclusion', // 年金保険適用除外理由
    },
    employmentInsurance: {
      employment_insurance_flag: 'employment_ins_status', // ccus雇用保険加入状況
      employment_insurance_reason_exclusion: 'employment_ins_exclusion', // ccus雇用保険適用除外理由
    },
    workerCompensationInsurance: {
      worker_compensation_flag: 'workmans_comp_ins_status', // ccus労災保険特別加入状況
    },
    subscriptionInsurance: {
      const_subscription_flag: 'kentaikyo_status', // ccus建退共制度加入状況
      const_subscription_number: 'kentaikyo_contractor_number', // ccus建退共契約者番号
      enterprise_subscription_flag: 'chutaikyo_status', // ccus中退共制度加入状況

    },
  };

  /**
   * valuesからcheckboxListのkey(PRESENCEなど)を取得
   * keyを元に安全書類項目の切り替えを判断するオブジェクトを作成
   * そのオブジェクトを元に、安全書類項目、ccusボタンの表示、非表示を制御する
   */

  // 健康保険加入状況
  const selectedHealthInsurance = findStatusFn(
    INSURANCE_STATUS,
    values.company_branch_insurance.health_insurance_flag
  );
  // 年金保険加入状況
  const selectedPensionInsurance = findStatusFn(
    INSURANCE_STATUS,
    values.company_branch_insurance.pension_flag
  );
  // 雇用保険加入状況
  const selectedEmploymentInsurance = findStatusFn(
    INSURANCE_STATUS,
    values.company_branch_insurance.employment_insurance_flag
  );
  // 労災保険特別加入状況
  const selectedWorkerCompensation = findStatusFn(
    WORKER_COMPENSATION_FLAG,
    values.company_branch_insurance.worker_compensation_flag
  );
  // 建退共制度加入状況
  const selectedConstSubscription = findStatusFn(
    CONST_SUBSCRIPTION_FLAG,
    values.company_branch_insurance.const_subscription_flag
  );
  // 中退共制度加入状況
  const selectedEnterpriseSubscription = findStatusFn(
    ENTERPRISE_SUBSCRIPTION_FLAG,
    values.company_branch_insurance.enterprise_subscription_flag
  );

  /**
   * 健康、年金、雇用保険の安全書類項目の表示、非表示制御用オブジェクト
   */
  const insuranceStatus = getInsuranceStatus({
    selectedHealthInsurance,
    selectedPensionInsurance,
    selectedEmploymentInsurance,
  });

  // 労災保険の安全書類項目の表示、非表示制御用オブジェクト
  const workerCompensationStatus = getWorkmansCompensationInsuranceStatus(
    selectedWorkerCompensation
  );
  // 建退共制度の安全書類項目の表示、非表示制御用オブジェクト
  const kentaikyoStatus = getKentaikyoInsuranceStatus(
    selectedConstSubscription
  );

  // 中退共制度の安全書類項目の表示、非表示制御用オブジェクト
  const chutaikyoStatus = getChutaikyoInsuranceStatus(
    selectedEnterpriseSubscription
  );

  // 建設業許可有無の安全書類項目の表示、非表示制御用
  const constructionIndustryPermissionStatus = isConstructionIndustryPermissionStatus(
    values.company_detail.construction_industry_permission_flag
  );

  // その他退職金共済制度の安全書類項目の表示、非表示制御用
  const OtherSubscriptionStatus = isOtherSubscriptionStatus(
    values.company_branch_insurance.other_subscription_flag
  );

  // 外国人就労者情報
  const AcceptanceForeignWorkersStatus = isAcceptanceForeignWorkersStatus(
    values.company_detail.acceptance_foreign_workers_flag
  );

  // const showElementClassName = `labor-safety__element`;
  // const hiddenElementClassName = `labor-safety__element--hidden`;
  const isShowCcus = !readOnly && gotCcusValues;

  const ccusComponents = (field, targetFields) => {
    return (
      isShowCcus && (
        <CcusTitleBlock
          onClick={e => {
            e.preventDefault();
            events.allInputInformation(field, targetFields);
          }}
        />
      )
    );
  };

  const ccusElement = (formValue, name, val, index) => {
    if (_.isEmpty(String(val))) {
      return null;
    }
    let label = val;
    let value = val;
    switch (name) {
      case 'construction_industry_permission_flag':
        label = FlagIndicator[val].name;
        value = FlagIndicator[val].id;
        break;
      case 'permitted_source_section':
        label = _.get(
          checkboxList.construct_permit_source_types,
          `${val}.construct_permit_source_type_name`
        );
        value = _.get(
          checkboxList.construct_permit_source_types,
          `${val}.construct_permit_source_type`
        );
        break;
      case 'construction_industry_permission_section':
        label = _.get(
          checkboxList.construct_permit_types,
          `${val}.construct_permit_type_name`
        );
        value = _.get(
          checkboxList.construct_permit_types,
          `${val}.construct_permit_type`
        );
        break;
      case 'health_insurance_flag':
      case 'pension_flag':
      case 'employment_insurance_flag':
        label = _.get(checkboxList.insurance_statuses, `${val}.name`);
        value = _.get(checkboxList.insurance_statuses, `${val}.value`);
        break;
      case 'worker_compensation_flag':
        label = _.get(
          checkboxList.workmans_compensation_insurance_statuses,
          `${val}.name`
        );
        value = _.get(
          checkboxList.workmans_compensation_insurance_statuses,
          `${val}.value`
        );
        break;
      case 'const_subscription_flag':
        label = _.get(checkboxList.kentaikyo_insurance_statuses, `${val}.name`);
        value = _.get(
          checkboxList.kentaikyo_insurance_statuses,
          `${val}.value`
        );
        break;
      case 'enterprise_subscription_flag':
        label = _.get(checkboxList.chutaikyo_insurance_statuses, `${val}.name`);
        value = _.get(
          checkboxList.chutaikyo_insurance_statuses,
          `${val}.value`
        );
        break;
      case 'other_subscription_flag':
        label = _.get(
          checkboxList.other_subscription_insurance_statuses,
          `${val}.name`
        );
        value = _.get(
          checkboxList.other_subscription_insurance_statuses,
          `${val}.value`
        );
        break;
      default:
        break;
    }
    return (
      isShowCcus && (
        <CcusLineComponent
          onClick={() =>
            events.setFormValue(formValue, { target: { name, value } }, index)
          }
        >
          {label}
        </CcusLineComponent>
      )
    );
  };

  const ccusElementCalendar = (formValue, key, value, index) => {
    return (
      isShowCcus &&
      !_.isEmpty(value) && (
        <CcusLineComponent
          onClick={() => events.setCalendar(formValue, key, value, index)}
        >
          {value}
        </CcusLineComponent>
      )
    );
  };

  /**
   * 健康保険_理由を表示するべきかどうかを判定する
   * @param {object} healthInsuranceFlag 加入状況のステータス
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceUninsuredReason = healthInsuranceFlag => {
    return healthInsuranceFlag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID;
  };

  /**
   * 健康保険_保険種類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceType = () => {
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_事業所整理記号を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceOfficeSymbol = () => {
    if (
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_事業所番号を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceOfficeNumber = () => {
    if (
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_保険者名称を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceNameInsurer = () => {
    if (
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }

    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };
  /**
   * 健康保険_添付書類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showAttachDocumentTypeCompanyHealthInsurance = () => {
    if (values.company_branch_insurance.health_insurance_flag !== null) {
      if (values.company_branch_insurance.health_insurance_flag !== '') {
        return true;
      }
    }
    return false;
  };

  /**
   * 年金保険_加入状況を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showPensionInsuranceType = () => {
    if (insuranceStatus.pensionPresence || insuranceStatus.pensionExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 年金保険_理由を表示するべきかどうかを判定する
   * @param {object} pentionInsuranceFlag 加入状況のステータス
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showPensionUninsuredReason = pentionInsuranceFlag => {
    return pentionInsuranceFlag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID;
  };

  /**
   * 年金保険_添付書類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showAttachDocumentTypeCompanyPensionInsurance = () => {
    if (values.company_branch_insurance.pension_flag !== null) {
      if (values.company_branch_insurance.pension_flag !== '') {
        return true;
      }
    }
    return false;
  };

  /**
   * 理由を表示するべきかどうかを判定する
   * @param {object} employmentInsuranceFlag 加入状況のステータス
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showEmploymentInsuranceUninsuredReason = employmentInsuranceFlag => {
    return employmentInsuranceFlag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID;
  };

  /**
   * 添付書類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showAttachDocumentTypeCompanyEmploymentInsurance = () => {
    if (values.company_branch_insurance.employment_insurance_flag !== null) {
      if (values.company_branch_insurance.employment_insurance_flag !== '') {
        return true;
      }
    }
    return false;
  };

  const renderHealthInsuranceTypeFormSelect = () => {
    // 加入状況が「有」、保険種類が任意項目の場合 (health_insurance_type = 'その他'、health_insurance_type_other = '任意項目')
    if (readOnly) {
      return (
        <span>{values.company_branch_insurance.health_insurance_type}</span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.health_insurance_type === 'その他'
      // ||
      // values.company_branch_insurance.health_insurance_reason_exclusion ===
      // 'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='health_insurance_type'
              value={
                values.company_branch_insurance.health_insurance_type !== null
                  ? values.company_branch_insurance.health_insurance_type
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(healthInsuranceTypesComboBoxList, (item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.health_insurance_type ===
            'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='health_insurance_type_other'
                type='text'
                value={
                  values.company_branch_insurance.health_insurance_type_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid={'health_insurance_type_other'}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }

    // 加入状況が「適用除外」、適用除外理由が「けんぽ適用除外承認済」の場合、保険種類に国民健康保険組合を表示する
    if (
      values.company_branch_insurance.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        'けんぽ適用除外承認済'
    ) {
      return (
        <span data-testid='health_insurance_type_text'>
          {values.company_branch_insurance.health_insurance_type}
        </span>
      );
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='health_insurance_type'
            value={
              values.company_branch_insurance.health_insurance_type !== null
                ? values.company_branch_insurance.health_insurance_type
                : ''
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={e => events.setFormValue('company_branch_insurance', e)}
          >
            <option value=''>選択してください</option>
            {_.map(healthInsuranceTypesComboBoxList, (item, index) => (
              <option key={index} value={item.name}>
                {item.name}
              </option>
            ))}
          </FormSelect>
        </FormElementContainerItem>
      </FormElementContainer>
    );
  };

  const renderHealthInsuranceReasonExclusionForm = () => {
    if (readOnly) {
      return (
        <span>
          {values.company_branch_insurance.health_insurance_reason_exclusion}
        </span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='health_insurance_reason_exclusion'
              value={
                values.company_branch_insurance
                  .health_insurance_reason_exclusion
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(
                comboboxList.health_insurance_exclusions,
                (item, index) => (
                  <option key={index} value={item.tekiyoujogai_reason}>
                    {item.tekiyoujogai_reason}
                  </option>
                )
              )}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.health_insurance_reason_exclusion ===
            'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='health_insurance_reason_exclusion_other'
                type='text'
                value={
                  values.company_branch_insurance
                    .health_insurance_reason_exclusion_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='health_insurance_reason_exclusion'
            value={
              values.company_branch_insurance
                .health_insurance_reason_exclusion !== null
                ? values.company_branch_insurance
                    .health_insurance_reason_exclusion
                : ''
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={e => events.setFormValue('company_branch_insurance', e)}
          >
            <option value=''>選択してください</option>
            {_.map(comboboxList.health_insurance_exclusions, (item, index) => (
              <option key={index} value={item.tekiyoujogai_reason}>
                {item.tekiyoujogai_reason}
              </option>
            ))}
          </FormSelect>
        </FormElementContainerItem>
      </FormElementContainer>
    );
  };

  const renderPensionTypeFormSelectWhenExist = () => {
    if (readOnly) {
      return <span>{values.company_branch_insurance.pension_type}</span>;
    }
    // 既存データ対応
    if (values.company_branch_insurance.pension_type === 'その他') {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_type'
              value={
                values.company_branch_insurance.pension_type !== null
                  ? values.company_branch_insurance.pension_type
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(pensionInsuranceTypesComboBoxList, (item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.pension_type === 'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='pension_type_other'
                type='text'
                value={values.company_branch_insurance.pension_type_other}
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid='pension_type_other'
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    return (
      <span data-testid='pension_type_exist'>
        {values.company_branch_insurance.pension_type}
      </span>
    );
  };

  const renderPensionTypeFormSelectWhenExclusion = () => {
    return (
      <span data-testid='pension_type_exclusion'>
        {values.company_branch_insurance.pension_type}
      </span>
    );
  };
  const renderPensionReasonExclusionFormSelect = () => {
    if (readOnly) {
      return (
        <span>{values.company_branch_insurance.pension_reason_exclusion}</span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.pension_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.pension_reason_exclusion === 'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_reason_exclusion'
              value={
                values.company_branch_insurance.pension_reason_exclusion !==
                null
                  ? values.company_branch_insurance.pension_reason_exclusion
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              <option value='５人未満個人事業所'>５人未満個人事業所</option>
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.pension_reason_exclusion ===
            'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='pension_reason_exclusion_other'
                type='text'
                value={
                  values.company_branch_insurance.pension_reason_exclusion_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid={'pension_reason_exclusion_other'}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    if (
      values.company_branch_insurance.pension_flag ===
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_reason_exclusion'
              value={
                values.company_branch_insurance.pension_reason_exclusion !==
                null
                  ? values.company_branch_insurance.pension_reason_exclusion
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              {_.map(
                comboboxList.pension_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </FormSelect>
          </FormElementContainerItem>
        </FormElementContainer>
      );
    }
  };

  const renderEmploymentInsuranceReasonExclusionFormSelect = () => {
    if (readOnly) {
      return (
        <span>
          {
            values.company_branch_insurance
              .employment_insurance_reason_exclusion
          }
        </span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.employment_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.employment_insurance_reason_exclusion ===
        'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='employment_insurance_reason_exclusion'
              value={
                values.company_branch_insurance
                  .employment_insurance_reason_exclusion
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(
                comboboxList.employment_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance
            .employment_insurance_reason_exclusion === 'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='employment_insurance_reason_exclusion_other'
                type='text'
                value={
                  values.company_branch_insurance
                    .employment_insurance_reason_exclusion_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid='employment_insurance_reason_exclusion_other'
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='employment_insurance_reason_exclusion'
            value={
              values.company_branch_insurance
                .employment_insurance_reason_exclusion
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={e => events.setFormValue('company_branch_insurance', e)}
          >
            <option value=''>選択してください</option>
            {_.map(
              comboboxList.employment_insurance_exclusions,
              (option, index) => {
                return (
                  <option value={option['tekiyoujogai_reason']} key={index}>
                    {option['tekiyoujogai_reason']}
                  </option>
                );
              }
            )}
          </FormSelect>
        </FormElementContainerItem>
      </FormElementContainer>
    );
  };

  // 加入状況が無(未加入)の場合、未加入でも良いと証明する書類を期待するメッセージを表示
  const renderDocumentationMessage = name => {
    return (
      !readOnly &&
      values[`company_branch_insurance`][name] ===
        EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID &&
      messageUtility.getMessage('I-000-135')
    );
  };

  const renderCompanySecurity = () => {
    return (
      <CompanySecurityInformation
        readOnly={readOnly}
        documentCodes={documentCodes}
        events={events}
        messages={messages}
        setFormValuesSecurityCompanyPermission={
          setFormValuesSecurityCompanyPermission
        }
        companySecurityValues={values.security_company_branch_permission_group}
        companyId={selectedCompanyId}
      />
    );
  };

  const renderCompanyConstructionIndustry = () => {
    return (
      <React.Fragment>
        <CompanyLicenseInformation
          events={events}
          values={values}
          readOnly={readOnly}
          bureaux={bureaux}
          checkboxList={checkboxList}
          industryDefault={comboboxList.construct_permit_industry_types}
          companyDocuments={companyDocuments}
          documentCodes={documentCodes}
          eventCompanyBranchPermissionCommon={
            eventCompanyBranchPermissionCommon
          }
          selectedCompanyId={selectedCompanyId}
          ccusCompanyBranchPermissions={ccusCompanyBranchPermissions}
        />
      </React.Fragment>
    );
  };

  const renderCompanyOtherIndustryLicense = () => {
    return (
      <CompanyOtherIndustryLicenseInformation
        events={events}
        values={values}
        readOnly={readOnly}
        checkboxList={checkboxList}
        documentCodes={documentCodes}
        constructionIndustries={comboboxList.construct_permit_industry_types}
        selectedCompanyId={selectedCompanyId}
        onDownloadFile={eventCompanyBranchPermissionCommon.download}
      />
    );
  };

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
      {ccusDescription}
      <FormList>
        {attentionBox && attentionBox}
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <InsuranceDocumentMyNumberCardWarning />
          </div>
        )}
        <FormListSubHeader
          title='代表者情報'
          ccusComponent={ccusComponents('company_detail')}
          noMarginTop
        />
        <FormListItem label='代表者名' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement(
              'company_detail',
              'delegate_name',
              ccusformValues.ccus_jigyousyas.daihyousya_name
            )}
          >
            <TextInput
              type='text'
              name='delegate_name'
              maxLength={255}
              disabled={readOnly}
              value={values.company_detail.delegate_name}
              onChange={e => events.setFormValue('company_detail', e)}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='代表者フリガナ'>
          <FormElement
            validate={
              _.has(messages, 'company_detail.delegate_name_kana') &&
              messages.company_detail.delegate_name_kana
            }
            ccusComponent={ccusElement(
              'company_detail',
              'delegate_name_kana',
              ccusformValues.ccus_jigyousyas.daihyousya_kana_name
            )}
          >
            <TextInput
              type='text'
              name='delegate_name_kana'
              maxLength={255}
              disabled={readOnly}
              value={values.company_detail.delegate_name_kana}
              onChange={e => events.setFormValue('company_detail', e)}
              onBlur={() => events.validate('company_detail')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='代表者役職' safetyDocItem={true}>
          <FormElement>
            <TextInput
              type='text'
              name='delegate_post'
              maxLength={255}
              disabled={readOnly}
              value={values.company_detail.delegate_post}
              onChange={e => events.setFormValue('company_detail', e)}
            />
          </FormElement>
        </FormListItem>
        {renderCompanyConstructionIndustry()}
        {renderCompanySecurity()}
        {renderCompanyOtherIndustryLicense()}
        <OldAttachmentPermission
          companyDocuments={values.old_company_permission_documents}
          documentCodes={documentCodes}
          events={events}
          readOnly={readOnly}
        />
        <CompanyInsuranceManual />
        <FormListSubHeader
          title='健康保険情報'
          ccusComponent={ccusComponents(
            'company_branch_insurance',
            insuranceCcusMap.healthInsurance
          )}
        />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に健康保険の加入内容証明書・社会保険納入証明書・領収済証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='health_insurance_flag'
        >
          <FormElement
            ccusComponent={ccusElement(
              'company_branch_insurance',
              'health_insurance_flag',
              ccusformValues.ccus_jigyousyas.health_ins_status
            )}
            info={renderDocumentationMessage('health_insurance_flag')}
          >
            <div className='form-list-radio'>
              {_.map(checkboxList.insurance_statuses, (answer, index) =>
                readOnly ? (
                  values.company_branch_insurance.health_insurance_flag ===
                    answer.value && <span key={index}>{answer.name}</span>
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-health_insurance_flag-${answer.id}`}
                        value={answer.value}
                        name='health_insurance_flag'
                        checked={
                          values.company_branch_insurance
                            .health_insurance_flag === answer.value
                        }
                        onChange={e =>
                          events.setFormValue('company_branch_insurance', e)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {insuranceStatus.healthExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='health_insurance_reason_exclusion'
          >
            <FormElement
              ccusComponent={ccusElement(
                'company_branch_insurance',
                'health_insurance_reason_exclusion',
                ccusformValues.ccus_jigyousyas.health_ins_exclusion
              )}
              info={
                values.company_branch_insurance
                  .health_insurance_reason_exclusion === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderHealthInsuranceReasonExclusionForm()}
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceUninsuredReason(
          values.company_branch_insurance.health_insurance_flag
        ) && (
          <FormListItem
            label='理由'
            data-testid='health_insurance_uninsured_reason'
          >
            <FormElement>
              <TextInput
                type='text'
                name='health_insurance_uninsured_reason'
                maxLength={255}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .health_insurance_uninsured_reason
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceType() && (
          <FormListItem label='保険種類' data-testid='health_insurance_type'>
            <FormElement
              info={
                values.company_branch_insurance.health_insurance_type ===
                  'その他' && <AdditionalInfoAboutOthers />
              }
            >
              {renderHealthInsuranceTypeFormSelect()}
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceNameInsurer() && (
          <FormListItem
            label='保険者名称'
            safetyDocItem={true}
            data-testid='health_insurance_name_insurer'
          >
            <FormElement>
              <TextInput
                type='text'
                name='health_insurance_name_insurer'
                maxLength={255}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.health_insurance_name_insurer
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceOfficeSymbol() && (
          <FormListItem
            label='事業所整理記号'
            safetyDocItem={true}
            data-testid='health_insurance_office_symbol'
          >
            <FormElement>
              <TextInput
                type='text'
                name='health_insurance_office_symbol'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.health_insurance_office_symbol
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceOfficeNumber() && (
          <FormListItem
            label='事業所番号'
            safetyDocItem={true}
            data-testid='health_insurance_office_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.health_insurance_office_number'
                ) &&
                messages.company_branch_insurance.health_insurance_office_number
              }
            >
              <TextInput
                type='text'
                name='health_insurance_office_number'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.health_insurance_office_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {showAttachDocumentTypeCompanyHealthInsurance() && (
          <FormListItem
            label='添付書類'
            data-testid='attach_document_type_company_health_insurance'
          >
            <FormElement>
              <AttachDocument
                requireConfirm={true}
                companyDocuments={_.filter(companyDocuments, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE
                  );
                })}
                documentCodes={_.filter(documentCodes, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE
                  );
                })}
                events={events}
                readOnly={readOnly}
                isFormListDefault
                indexId={ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListSubHeader
          title='年金保険情報'
          ccusComponent={ccusComponents(
            'company_branch_insurance',
            insuranceCcusMap.pensionInsurance
          )}
        />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に年金保険の適用通知書・社会保険納入証明書・領収済証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='pension_flag'
        >
          <FormElement
            ccusComponent={ccusElement(
              'company_branch_insurance',
              'pension_flag',
              ccusformValues.ccus_jigyousyas.pension_ins_status
            )}
            info={renderDocumentationMessage('pension_flag')}
          >
            <div className='form-list-radio'>
              {_.map(checkboxList.insurance_statuses, (answer, index) =>
                readOnly ? (
                  values.company_branch_insurance.pension_flag ===
                    answer.value && <span key={index}>{answer.name}</span>
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-pension_flag-${answer.id}`}
                        value={answer.value}
                        name='pension_flag'
                        checked={
                          values.company_branch_insurance.pension_flag ===
                          answer.value
                        }
                        onChange={e =>
                          events.setFormValue('company_branch_insurance', e)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {insuranceStatus.pensionExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='pension_reason_exclusion'
          >
            <FormElement
              ccusComponent={ccusElement(
                'company_branch_insurance',
                'pension_reason_exclusion',
                ccusformValues.ccus_jigyousyas.pension_ins_exclusion
              )}
              info={
                values.company_branch_insurance.pension_reason_exclusion ===
                  'その他' && <AdditionalInfoAboutOthers />
              }
            >
              {renderPensionReasonExclusionFormSelect()}
            </FormElement>
          </FormListItem>
        )}
        {showPensionUninsuredReason(
          values.company_branch_insurance.pension_flag
        ) && (
          <FormListItem label='理由' data-testid='pension_uninsured_reason'>
            <FormElement>
              <TextInput
                type='text'
                name='pension_uninsured_reason'
                maxLength={255}
                disabled={readOnly}
                value={values.company_branch_insurance.pension_uninsured_reason}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {showPensionInsuranceType() && (
          <FormListItem label='保険種類' data-testid='pension_type'>
            <FormElement
              info={
                values.company_branch_insurance.pension_type === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderPensionTypeFormSelectWhenExist()}
              {/* {values.company_branch_insurance.pension_flag ===
              EXISTANCE_EXCLUSION_FLAG.EXIST.ID
                ? renderPensionTypeFormSelectWhenExist()
                : renderPensionTypeFormSelectWhenExclusion()} */}
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.pensionPresence && (
          <FormListItem
            label='事業所整理記号'
            safetyDocItem={true}
            data-testid='pension_office_symbol'
          >
            <FormElement>
              <TextInput
                type='text'
                name='pension_office_symbol'
                maxLength={20}
                disabled={readOnly}
                value={values.company_branch_insurance.pension_office_symbol}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.pensionPresence && (
          <FormListItem
            label='事業所番号'
            safetyDocItem={true}
            data-testid='pension_office_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.pension_office_number'
                ) && messages.company_branch_insurance.pension_office_number
              }
            >
              <TextInput
                type='text'
                name='pension_office_number'
                maxLength={20}
                disabled={readOnly}
                value={values.company_branch_insurance.pension_office_number}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {showAttachDocumentTypeCompanyPensionInsurance() && (
          <FormListItem
            label='添付書類'
            data-testid='attach_document_type_company_pension_insurance'
          >
            <FormElement>
              <AttachDocument
                companyDocuments={_.filter(companyDocuments, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE
                  );
                })}
                documentCodes={_.filter(documentCodes, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE
                  );
                })}
                events={events}
                readOnly={readOnly}
                isFormListDefault
                indexId={ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListSubHeader
          title='雇用保険情報'
          ccusComponent={ccusComponents(
            'company_branch_insurance',
            insuranceCcusMap.employmentInsurance
          )}
        />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に雇用保険の加入証明証・労働保険料納入通知書・領収済証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='employment_insurance_flag'
        >
          <FormElement
            ccusComponent={ccusElement(
              'company_branch_insurance',
              'employment_insurance_flag',
              ccusformValues.ccus_jigyousyas.employment_ins_status
            )}
            info={renderDocumentationMessage('employment_insurance_flag')}
          >
            <div className='form-list-radio'>
              {_.map(checkboxList.insurance_statuses, (answer, index) =>
                readOnly ? (
                  values.company_branch_insurance.employment_insurance_flag ===
                    answer.value && <span key={index}>{answer.name}</span>
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-employment_insurance_flag-${answer.id}`}
                        value={answer.value}
                        name='employment_insurance_flag'
                        checked={
                          values.company_branch_insurance
                            .employment_insurance_flag === answer.value
                        }
                        onChange={e =>
                          events.setFormValue('company_branch_insurance', e)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {insuranceStatus.employmentExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='employment_insurance_reason_exclusion'
          >
            <FormElement
              ccusComponent={ccusElement(
                'company_branch_insurance',
                'employment_insurance_reason_exclusion',
                ccusformValues.ccus_jigyousyas.employment_ins_exclusion
              )}
              info={
                values.company_branch_insurance
                  .employment_insurance_reason_exclusion === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderEmploymentInsuranceReasonExclusionFormSelect()}
            </FormElement>
          </FormListItem>
        )}
        {showEmploymentInsuranceUninsuredReason(
          values.company_branch_insurance.employment_insurance_flag
        ) && (
          <FormListItem
            label='理由'
            data-testid='employment_insurance_uninsured_reason'
          >
            <FormElement>
              <TextInput
                type='text'
                name='employment_insurance_uninsured_reason'
                maxLength={255}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .employment_insurance_uninsured_reason
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.employmentPresence && (
          <FormListItem
            label='労働保険番号'
            safetyDocItem={true}
            data-testid='employment_insurance_insurance_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.employment_insurance_insurance_number'
                ) &&
                messages.company_branch_insurance
                  .employment_insurance_insurance_number
              }
            >
              <TextInput
                type='text'
                name='employment_insurance_insurance_number'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .employment_insurance_insurance_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {showAttachDocumentTypeCompanyEmploymentInsurance() && (
          <FormListItem
            label='添付書類'
            data-testid='attach_document_type_company_employment_insurance'
          >
            <FormElement>
              <AttachDocument
                companyDocuments={_.filter(companyDocuments, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE
                  );
                })}
                documentCodes={_.filter(documentCodes, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE
                  );
                })}
                events={events}
                readOnly={readOnly}
                isFormListDefault
                indexId={ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE}
              />
            </FormElement>
          </FormListItem>
        )}
        <WorkerAddOnCompensationForm
          readOnly={readOnly}
          events={events}
          insuranceInfo={values.company_branch_insurance}
          checkboxList={checkboxList}
          companyDocuments={companyDocuments}
          documentCodes={documentCodes}
          validateMessages={messages.company_branch_insurance || {}}
        />
        <FormListSubHeader
          title='労災保険特別加入情報'
          ccusComponent={ccusComponents(
            'company_branch_insurance',
            insuranceCcusMap.workerCompensationInsurance
          )}
        />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              <React.Fragment>
                中小事業主（労働者数300人以下）や一人親方の場合で、労災保険の特別加入制度（※）に加入済みの方は入力してください。
                <br />
                法人の場合は、加入状況[無]を選択してください。
                <br />
                ※
                中小事業主（労働者数300人以下）や一人親方に対して特別に任意加入が認められた労災保険の事です。
                <br />
                労働者向けの一般的な労災保険ではありませんので、ご注意ください。
              </React.Fragment>
            </Description>
          </div>
        )}
        <FormListItem label='加入状況' data-testid='worker_compensation_flag'>
          <FormElement
            ccusComponent={ccusElement(
              'company_branch_insurance',
              'worker_compensation_flag',
              ccusformValues.ccus_jigyousyas.workmans_comp_ins_status
            )}
          >
            <div className='form-list-radio'>
              {_.map(
                checkboxList.workmans_compensation_insurance_statuses,
                (answer, index) =>
                  readOnly ? (
                    values.company_branch_insurance.worker_compensation_flag ===
                      answer.value && <span key={index}>{answer.name}</span>
                  ) : (
                    <div className='form-list-radio__item' key={index}>
                      <label className='radio'>
                        <input
                          type='radio'
                          id={`form-radio-worker_compensation_flag-${answer.id}`}
                          value={answer.value}
                          name='worker_compensation_flag'
                          checked={
                            values.company_branch_insurance
                              .worker_compensation_flag === answer.value
                          }
                          onChange={e =>
                            events.setFormValue('company_branch_insurance', e)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>{answer.name}</span>
                      </label>
                    </div>
                  )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {workerCompensationStatus.presence && (
          <FormListItem
            label='労働保険番号'
            data-testid='worker_compensation_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.worker_compensation_number'
                ) &&
                messages.company_branch_insurance.worker_compensation_number
              }
            >
              <TextInput
                type='text'
                list='worker_compensation_number-list'
                name='worker_compensation_number'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.worker_compensation_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {workerCompensationStatus.presence && (
          <FormListItem
            label='整理番号'
            data-testid='worker_compensation_organize_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.worker_compensation_organize_number'
                ) &&
                messages.company_branch_insurance
                  .worker_compensation_organize_number
              }
            >
              <TextInput
                type='text'
                name='worker_compensation_organize_number'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .worker_compensation_organize_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListItem
          label='添付書類'
          data-testid='attach_document_type_company_worker_compensation_insurance'
        >
          <FormElement>
            <AttachDocument
              companyDocuments={_.filter(companyDocuments, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
                );
              })}
              documentCodes={_.filter(documentCodes, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
                );
              })}
              events={events}
              readOnly={readOnly}
              isFormListDefault
              indexId={
                ATTACH_DOCUMENT_TYPE_COMPANY.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
              }
            />
          </FormElement>
        </FormListItem>
        <FormListSubHeader
          title='退職金共済情報'
          ccusComponent={ccusComponents(
            'company_branch_insurance',
            insuranceCcusMap.subscriptionInsurance
          )}
        />
        <FormListItem label='建退共制度加入状況' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement(
              'company_branch_insurance',
              'const_subscription_flag',
              ccusformValues.ccus_jigyousyas.kentaikyo_status
            )}
          >
            <div className='form-list-radio'>
              {_.map(
                checkboxList.kentaikyo_insurance_statuses,
                (answer, index) =>
                  readOnly ? (
                    values.company_branch_insurance.const_subscription_flag ===
                      answer.value && <span key={index}>{answer.name}</span>
                  ) : (
                    <div className='form-list-radio__item' key={index}>
                      <label className='radio'>
                        <input
                          type='radio'
                          id={`form-radio-const_subscription_flag-${answer.id}`}
                          value={answer.value}
                          name='const_subscription_flag'
                          checked={
                            values.company_branch_insurance
                              .const_subscription_flag === answer.value
                          }
                          onChange={e =>
                            events.setFormValue('company_branch_insurance', e)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>{answer.name}</span>
                      </label>
                    </div>
                  )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {kentaikyoStatus.presence && (
          <FormListItem label='建退共契約者番号'>
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.const_subscription_number'
                ) && messages.company_branch_insurance.const_subscription_number
              }
              ccusComponent={ccusElement(
                'company_branch_insurance',
                'const_subscription_number',
                ccusformValues.ccus_jigyousyas.kentaikyo_contractor_number
              )}
              info={
                !readOnly &&
                '建設業退職金共済事業加入・履行証明願または、建設業退職金共済契約者証をご用意頂きご登録頂くとスムーズです。'
              }
            >
              <TextInput
                type='text'
                name='const_subscription_number'
                placeholder='1234567'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.const_subscription_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListItem label='中退共制度加入状況' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement(
              'company_branch_insurance',
              'enterprise_subscription_flag',
              ccusformValues.ccus_jigyousyas.chutaikyo_status
            )}
          >
            <div className='form-list-radio'>
              {_.map(
                checkboxList.chutaikyo_insurance_statuses,
                (answer, index) =>
                  readOnly ? (
                    values.company_branch_insurance
                      .enterprise_subscription_flag === answer.value && (
                      <span key={index}>{answer.name}</span>
                    )
                  ) : (
                    <div className='form-list-radio__item' key={index}>
                      <label className='radio'>
                        <input
                          type='radio'
                          id={`form-radio-enterprise_subscription_flag-${answer.id}`}
                          value={answer.value}
                          name='enterprise_subscription_flag'
                          checked={
                            values.company_branch_insurance
                              .enterprise_subscription_flag === answer.value
                          }
                          onChange={e =>
                            events.setFormValue('company_branch_insurance', e)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>{answer.name}</span>
                      </label>
                    </div>
                  )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {chutaikyoStatus.presence && (
          <FormListItem label='中退共契約者番号'>
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.enterprise_subscription_number'
                ) &&
                messages.company_branch_insurance.enterprise_subscription_number
              }
              info={
                !readOnly &&
                '中小企業退職金共済制度加入証明書または、中小企業退職金共済手帳をご用意頂きご登録頂くとスムーズです。'
              }
            >
              <TextInput
                type='text'
                name='enterprise_subscription_number'
                placeholder='1234567'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.enterprise_subscription_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListItem label='その他退職金共済加入状況' safetyDocItem={true}>
          <FormElement>
            <div className='form-list-radio'>
              {_.map(
                checkboxList.other_subscription_insurance_statuses,
                (answer, index) =>
                  readOnly ? (
                    values.company_branch_insurance.other_subscription_flag ===
                      answer.value && <span key={index}>{answer.name}</span>
                  ) : (
                    <div className='form-list-radio__item' key={index}>
                      <label className='radio'>
                        <input
                          type='radio'
                          id={`form-radio-other_subscription_flag-${answer.id}`}
                          value={answer.value}
                          name='other_subscription_flag'
                          checked={
                            values.company_branch_insurance
                              .other_subscription_flag === answer.value
                          }
                          onChange={e =>
                            events.setFormValue('company_branch_insurance', e)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>{answer.name}</span>
                      </label>
                    </div>
                  )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {OtherSubscriptionStatus && (
          <FormListItem label='その他退職金共済制度名称'>
            <FormElement>
              <TextInput
                type='text'
                name='other_subscription_name'
                maxLength={255}
                disabled={readOnly}
                value={values.company_branch_insurance.other_subscription_name}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListItem label='退職金共済加入証明書'>
          <FormElement>
            <AttachDocument
              companyDocuments={_.filter(companyDocuments, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.RETIREMENT_MUTUAL_AID
                );
              })}
              documentCodes={_.filter(documentCodes, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.RETIREMENT_MUTUAL_AID
                );
              })}
              events={events}
              readOnly={readOnly}
              isFormListDefault
              indexId={ATTACH_DOCUMENT_TYPE_COMPANY.RETIREMENT_MUTUAL_AID}
            />
          </FormElement>
        </FormListItem>
        <FormListSubHeader title='外国人就労者情報' />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に建設特定技能受入計画認定証・適正監理計画認定証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem label='外国人就労者受入有無' safetyDocItem={true}>
          <FormElement>
            <div className='form-list-radio'>
              {_.map(AcceptanceForeignWorkersFlag, (answer, index) =>
                readOnly ? (
                  String(
                    values.company_detail.acceptance_foreign_workers_flag
                  ) === String(answer.id) && (
                    <span key={index}>{answer.name}</span>
                  )
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-acceptance_foreign_workers_flag-${answer.id}`}
                        value={answer.id}
                        name='acceptance_foreign_workers_flag'
                        checked={
                          String(
                            values.company_detail
                              .acceptance_foreign_workers_flag
                          ) === String(answer.id)
                        }
                        onChange={e => events.setFormValue('company_detail', e)}
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {AcceptanceForeignWorkersStatus && (
          <React.Fragment>
            <FormListItem label='適正監理計画認定番号'>
              <FormElement>
                <TextInput
                  type='text'
                  name='certification_number'
                  maxLength={20}
                  disabled={readOnly}
                  value={values.company_branch_foreigner.certification_number}
                  onChange={e =>
                    events.setFormValue('company_branch_foreigner', e)
                  }
                />
              </FormElement>
            </FormListItem>
            <FormListItem label='受入監理責任者名' safetyDocItem={true}>
              <FormElement>
                <TextInput
                  type='text'
                  name='supervisor_name'
                  maxLength={255}
                  disabled={readOnly}
                  value={values.company_branch_foreigner.supervisor_name}
                  onChange={e =>
                    events.setFormValue('company_branch_foreigner', e)
                  }
                />
              </FormElement>
            </FormListItem>
            <FormListItem label='受入監理責任者役職名' safetyDocItem={true}>
              <FormElement>
                <TextInput
                  type='text'
                  name='supervisor_position_name'
                  maxLength={255}
                  disabled={readOnly}
                  value={
                    values.company_branch_foreigner.supervisor_position_name
                  }
                  onChange={e =>
                    events.setFormValue('company_branch_foreigner', e)
                  }
                />
              </FormElement>
            </FormListItem>
            <FormListItem label='受入監理責任者電話番号' safetyDocItem={true}>
              <FormElement
                validate={
                  _.has(messages, 'company_branch_foreigner.supervisor_tel') &&
                  messages.company_branch_foreigner.supervisor_tel
                }
              >
                <Tel
                  htmlFor='supervisor_tel'
                  tableName={'company_branch_foreigner'}
                  targetName={'supervisor_tel'}
                  value={values.company_branch_foreigner.supervisor_tel}
                  readOnly={readOnly}
                  events={events}
                />
              </FormElement>
            </FormListItem>
            {values.company_branch_foreigner.work_place && (
              <FormListItem label='就労場所'>
                <FormElement
                  warning={!readOnly && messageUtility.getMessage('W-000-029')}
                >
                  <TextInput
                    type='text'
                    name='work_place'
                    maxLength={255}
                    disabled={true}
                    value={values.company_branch_foreigner.work_place}
                  />
                </FormElement>
              </FormListItem>
            )}
            <FormListItem label='従事業務内容'>
              <FormElement>
                <TextInput
                  type='text'
                  name='engagement_content'
                  maxLength={255}
                  disabled={readOnly}
                  value={values.company_branch_foreigner.engagement_content}
                  onChange={e =>
                    events.setFormValue('company_branch_foreigner', e)
                  }
                />
              </FormElement>
            </FormListItem>
            <FormListItem label='業務区分' safetyDocItem={true}>
              <FormElement
                warning={workerCategoryWarningText}
                info={!readOnly && messageUtility.getMessage('I-000-265')}
              >
                <TextInput
                  type='text'
                  name='work_category'
                  maxLength={255}
                  disabled={readOnly}
                  value={values.company_branch_foreigner.work_category}
                  onChange={e =>
                    events.setFormValue('company_branch_foreigner', e)
                  }
                />
              </FormElement>
            </FormListItem>
            <FormListItem
              label='従事開始年月日 (計画期間)'
              safetyDocItem={true}
            >
              {(values.company_branch_foreigner.engagement_start_date ||
                !readOnly) && (
                <DateInput
                  dateString={
                    values.company_branch_foreigner.engagement_start_date
                  }
                  disabled={readOnly}
                  onChangeValue={date =>
                    events.setCalendar(
                      'company_branch_foreigner',
                      'engagement_start_date',
                      date
                    )
                  }
                  isPreview={readOnly}
                  message={
                    messages.company_branch_foreigner &&
                    messages.company_branch_foreigner.engagement_start_date
                  }
                  jpDelimiterChar={true}
                  onBlur={() => events.validate('company_branch_foreigner')}
                />
              )}
            </FormListItem>
            <FormListItem
              label='従事終了年月日 (計画期間)'
              safetyDocItem={true}
            >
              {(values.company_branch_foreigner.engagement_end_date ||
                !readOnly) && (
                <DateInput
                  dateString={
                    values.company_branch_foreigner.engagement_end_date
                  }
                  disabled={readOnly}
                  onChangeValue={date =>
                    events.setCalendar(
                      'company_branch_foreigner',
                      'engagement_end_date',
                      date
                    )
                  }
                  isPreview={readOnly}
                  message={
                    messages.company_branch_foreigner &&
                    messages.company_branch_foreigner.engagement_end_date
                  }
                  jpDelimiterChar={true}
                  onBlur={() => events.validate('company_branch_foreigner')}
                />
              )}
            </FormListItem>
          </React.Fragment>
        )}
        <FormListItem label='添付書類'>
          <FormElement>
            <AttachDocument
              companyDocuments={_.filter(companyDocuments, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN
                );
              })}
              documentCodes={_.filter(documentCodes, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN
                );
              })}
              events={events}
              readOnly={readOnly}
              isFormListDefault
              indexId={ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN}
            />
          </FormElement>
        </FormListItem>
        {!readOnly && (
          <div className='form-list__qr-message'>
            ※QRコードは(株)デンソーウェーブの登録商標です。
          </div>
        )}
      </FormList>
    </div>
  );
};

const Tel = props => {
  let tel1 = '';
  let tel2 = '';
  let tel3 = '';

  if (props.value && props.value !== 'undefined') {
    const tel = props.value.split('-');
    if (tel.length > 0) {
      tel1 = tel[0];
      tel2 = tel[1];
      tel3 = tel[2];
    }
  }
  // 詳細かつ電話番号が設定されていない時、--は表示しない
  if (props.readOnly) {
    if (tel1 === '' && tel2 === '' && tel3 === '') {
      return '';
    }
  }

  return (
    <label htmlFor={props.htmlFor} className='input-tel'>
      <input
        type={'text'}
        maxLength={'5'}
        disabled={props.readOnly}
        value={tel1}
        onChange={e => {
          props.events.setFormValueTel(
            props.tableName,
            props.targetName,
            joinTel(e.target.value, tel2, tel3)
          );
        }}
        onBlur={() => {
          if (!props.readOnly) {
            props.events.validate(props.tableName);
          }
        }}
      />
      -
      <input
        type={'text'}
        maxLength={'4'}
        disabled={props.readOnly}
        value={tel2}
        onChange={e => {
          props.events.setFormValueTel(
            props.tableName,
            props.targetName,
            joinTel(tel1, e.target.value, tel3)
          );
        }}
        onBlur={() => {
          if (!props.readOnly) {
            props.events.validate(props.tableName);
          }
        }}
      />
      -
      <input
        type={'text'}
        maxLength={'4'}
        disabled={props.readOnly}
        value={tel3}
        onChange={e => {
          props.events.setFormValueTel(
            props.tableName,
            props.targetName,
            joinTel(tel1, tel2, e.target.value)
          );
        }}
        onBlur={() => {
          if (!props.readOnly) {
            props.events.validate(props.tableName);
          }
        }}
      />
    </label>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/PartnerCompanySafty.jsx